import { Injectable }    from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';

import { NotifyService } from './addon/notify.service';

import 'rxjs/add/operator/toPromise';
declare var $:any;

@Injectable()
export class AppServices {
  session = [];
  headers = new Headers({'Content-Type': 'application/json'});
  appname = 'pmi';
  accountcode = 'HJtEms7aV';
  // host = 'http://localhost:2600';
  host = 'https://erp.vsci.guru';
  // host_ai = 'http://localhost:3800/api/';
  host_ai = 'https://sbi.gogoviet.com/api/';

  API_METHOD = this.host + '/api/';

  constructor(private http: Http, private router: Router, private notifyServices: NotifyService) { }

  /* FUNCTION */
  api(method, data, component): any {
    return this.handleAPI(this.API_METHOD + method, data, component);
  }
  api_ai(method, data, component): any {
    return this.handleAPI(this.host_ai + method, data, component);
  }
  getStorage(key) {
    return localStorage.getItem(`${this.appname}[${key}]`) ? localStorage.getItem(`${this.appname}[${key}]`) : '[]';
  }
  setStorage(key, value) {
    if(value) {
      return localStorage.setItem(`${this.appname}[${key}]`, value);
    }
  }
  removeStorage() {
    localStorage.clear();
  }


  /* Common Function */
  private handleAPI(URL, data, component) {
    $('.loading').fadeIn();
    return new Promise((resolve, reject) => {
      this.http.post(URL, data, {headers: this.headers})
      .toPromise()
      .then(function (response) {
        setTimeout(function(){
          $('.loading').fadeOut();
        }, 500);
        resolve({response, component});
      })
      .catch((err) => {
        setTimeout(function(){
          $('.loading').fadeOut();
        }, 500);
        this.router.navigate(['/main/home']);
        reject({err, component});
      });
    });
  }
}


// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/app.services.ts